<template>
    <footer>
        <div class="documents">
            <router-link to="/user-agreement" target="_blank" class="mail-link">
                {{ $t('title.userAgreement') }}
            </router-link>
            
            <router-link to="/privacy-policy" target="_blank" class="mail-link">
                {{ $t('title.privacyPolicy') }}
            </router-link>
        </div>
        
        <div class="footer-text pl-3">
            {{ $t('message.anyProblems') }}<a class="mail-link pl-1" href="https://support.infomir.ru/open.php" target="_blank">{{ $t('button.letterUs') }}</a>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'FooterInfomir'
    };
</script>

<style scoped>
    footer {
        background-color: #333333;
        height: 2.5rem;
        flex-wrap: nowrap;
        padding: 0.5rem 1rem;
        z-index: 1030;
        position: fixed;
        bottom: 0;
        right: 0;
        left: 0;
        color: white;
        font-size: 14px;
        font-weight: 300;
        
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    .documents {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .mail-link {
        color: white;
        text-decoration: underline;
    }
    
    @media screen and (max-width: 650px) {
        footer {
            flex-direction: column;
            height: 6rem;
        }
        
        .documents {
            flex-direction: column;
        }
    }
</style>
